import React from 'react';
import { PhoneIcon } from 'lucide-react';
export function ContactSection() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-508">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-509">
        <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border text-center" style={{
        borderColor: '#ede9e0'
      }} data-id="element-510">
          <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" style={{
          backgroundColor: 'rgba(200,168,75,0.15)'
        }} data-id="element-511">
            <PhoneIcon size={24} style={{
            color: '#c8a84b'
          }} data-id="element-512" />
          </div>
          <h2 className="text-2xl font-bold uppercase mb-2" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-513">
            Contact Rental Agent
          </h2>
          <p className="text-base text-gray-600 mb-4" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-514">
            Contact <strong data-id="element-515">Regina Landon</strong> (Rental Lease Agent) for more
            options and details.
          </p>
          <a href="tel:8109386008" className="inline-flex items-center gap-2 text-lg font-semibold transition-colors hover:underline" style={{
          color: '#1e3d2f',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-516">
            <PhoneIcon size={18} data-id="element-517" />
            810-938-6008
          </a>
        </div>
      </div>
    </div>;
}